import React, { Component } from "react";
import axios from "axios";
import styled from "styled-components";
import { withRouter } from "react-router-dom";

import PaginationButtons from "../../../commons/components/pagination/PaginationButtons";
import { ROUTES } from "../../../commons/constants/routes/routes";
import { getUpdatedSearchParam } from "../../../commons/services/Router";

class InquiryMain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      filteredItems: [],
      pageItems: [],
      totalCount: 0,
      currentPage: null,
      totalPageCount: 0,
      maxItemsPerPage: 10,
      keyword: "",
      searchType: "subject",
      approveState: "",
      orderType: "DESC",
    };
    this.getItems = this.getItems.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.updatePageParam = this.updatePageParam.bind(this);
  }

  async componentDidMount() {
    this.initPaginationSearchParam();
    await this.getItems();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPage !== this.state.currentPage) {
      this.setPagination();
    }
    if (prevProps.location.search !== this.props.location.search) {
      const page = this.getPageSearchParam();
      if (page) this.setState({ currentPage: Number(page) }, this.setPagination);
    }
  }

  getPageSearchParam() {
    return new URLSearchParams(this.props.location.search).get("page");
  }

  initPaginationSearchParam() {
    const page = this.getPageSearchParam() || 1;
    this.setState({ currentPage: Number(page) });
  }

  updatePageParam(page) {
    const updatedParams = getUpdatedSearchParam({ page }, this.props.location);
    this.props.history.push({ pathname: this.props.location.pathname, search: updatedParams });
  }

  setPagination() {
    const { filteredItems, currentPage } = this.state;
    const pageList = [];
    filteredItems.forEach((item, index) => {
      if (index % 10 === 0) pageList.push([...filteredItems.slice(index, index + 10)]);
    });
    this.setState({ pageItems: pageList[currentPage - 1] || [] });
  }

  async getItems() {
    try {
      const res = await axios.get("/cst/api/inquiry");
      const items = res.data.data || res.data.list || [];
      this.setState({ items, totalCount: items.length }, this.handleSearch);
    } catch (e) {
      console.log(e);
    }
  }

  handleSearchChange(e) {
    this.setState({ [e.target.id]: e.target.value });
  }

  handleSearch(e) {
    if (e) e.preventDefault();
    const { items, keyword, searchType, approveState, orderType } = this.state;

    let filtered = [...items];

    if (keyword) {
      filtered = filtered.filter((item) => {
        if (searchType === "subject") return item.title && item.title.includes(keyword);
        if (searchType === "name") return item.userName && item.userName.includes(keyword);
        return false;
      });
    }

    if (approveState !== "") {
      const approved = approveState === "true";
      filtered = filtered.filter((item) => item.approveState === approved);
    }

    if (orderType === "ASC") {
      filtered.sort((a, b) => new Date(a.inquiryDt) - new Date(b.inquiryDt));
    } else {
      filtered.sort((a, b) => new Date(b.inquiryDt) - new Date(a.inquiryDt));
    }

    this.setState(
      {
        filteredItems: filtered,
        totalPageCount: Math.ceil(filtered.length / this.state.maxItemsPerPage),
      },
      this.setPagination
    );
  }

  render() {
    const { keyword, searchType, approveState, orderType, filteredItems, pageItems } = this.state;

    return (
      <Wrap>
        <div className="page-tit gray">
          <div className="container f-stack">
            <h2 className="tit">문의 관리</h2>
          </div>
        </div>
        <div className="container">
          <div className="top-search">
            <p className="all">
              문의 목록<span> 총 {this.state.totalCount}건</span>
            </p>
            <div className="search">
              <form onSubmit={this.handleSearch}>
                <select
                  id="orderType"
                  title="정렬선택"
                  value={orderType}
                  onChange={(e) => this.setState({ orderType: e.target.value }, this.handleSearch)}
                >
                  <option value="DESC">최신순</option>
                  <option value="ASC">오래된순</option>
                </select>
                <select
                  id="approveState"
                  title="답변여부"
                  value={approveState}
                  onChange={(e) => this.setState({ approveState: e.target.value }, this.handleSearch)}
                >
                  <option value="">전체</option>
                  <option value="false">미답변</option>
                  <option value="true">답변완료</option>
                </select>
                <select
                  id="searchType"
                  title="검색유형"
                  value={searchType}
                  onChange={this.handleSearchChange}
                >
                  <option value="subject">제목</option>
                  <option value="name">이름</option>
                </select>
                <div className="input-search">
                  <input
                    type="text"
                    id="keyword"
                    placeholder="검색어를 입력하세요"
                    value={keyword}
                    onChange={this.handleSearchChange}
                  />
                  <button type="submit" className="material-icons">
                    search
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="table-wrapper">
            <table className="h-table">
              <colgroup>
                <col style={{ width: "5%" }} />
                <col style={{ width: "28%" }} />
                <col style={{ width: "10%" }} />
                <col style={{ width: "18%" }} />
                <col style={{ width: "13%" }} />
                <col style={{ width: "12%" }} />
                <col style={{ width: "9%" }} />
                <col style={{ width: "5%" }} />
              </colgroup>
              <thead>
                <tr>
                  <th>번호</th>
                  <th>제목</th>
                  <th>문의자</th>
                  <th>이메일</th>
                  <th>연락처</th>
                  <th>등록일</th>
                  <th>답변여부</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pageItems.length > 0 ? (
                  pageItems.map((row, index) => (
                    <tr key={row.id}>
                      <td>
                        {this.state.totalCount - ((this.state.currentPage - 1) * 10 + index)}
                      </td>
                      <td className="ellipsis" title={row.title}>{row.title}</td>
                      <td>{row.userName}</td>
                      <td className="ellipsis" title={row.email}>{row.email}</td>
                      <td>{row.phone}</td>
                      <td>{row.inquiryDt}</td>
                      <td>
                        <StateBadge answered={row.approveState}>
                          {row.approveState ? "답변완료" : "미답변"}
                        </StateBadge>
                      </td>
                      <td>
                        <button
                          className="detail-btn link-btn"
                          onClick={() => this.props.history.push(ROUTES.CS_INQUIRY.DETAIL(row.id))}
                        >
                          상세
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8">등록된 문의가 없습니다.</td>
                  </tr>
                )}
              </tbody>
            </table>
            {filteredItems.length > 10 && (
              <PaginationButtons
                totalPageCount={this.state.totalPageCount}
                currentPage={this.state.currentPage}
                onChangePage={this.updatePageParam}
              />
            )}
          </div>
        </div>
      </Wrap>
    );
  }
}

const Wrap = styled.div`
  .top-search .all {
    font-size: 15px;
    font-weight: bold;
    color: #191919;
    span {
      font-weight: normal;
      color: #888e98;
      display: inline-block;
      margin-left: 10px;
    }
  }
  .search form {
    select {
      border: 1px solid #d5d8de;
      margin-right: 12px;
    }
  }
  .ellipsis {
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .link-btn {
    display: inline-block;
    font-size: 12px;
    width: 45px;
    padding: 3px 0;
    text-align: center;
    border-radius: 5px;
    cursor: pointer;
    border: none;
  }
  .detail-btn {
    background-color: var(--secondary-500);
    border: 1px solid var(--secondary-500);
    color: #fff;
    &:hover {
      background-color: var(--secondary-600);
      border-color: var(--secondary-600);
    }
  }
`;

const StateBadge = styled.span`
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  color: ${({ answered }) => (answered ? "#1ab245" : "#ff5353")};
  background-color: ${({ answered }) => (answered ? "#e8f8ed" : "#fff0f0")};
`;

export default withRouter(InquiryMain);
